import {
  TSetCommonItemFn,
  TGetCommonItemWithExpirationFn,
  TRemoveCommonItemFn,
  TPrefix,
} from './types'

import { getCommonItem, setCommonItem, buildKey, removeCommonItem } from '.'

export function isKeyExpired(key: string, prefix: TPrefix, timeout: number): boolean {
  let _key = buildKey(key, prefix)
  _key = _key + '__dt'
  const ts = getCommonItem(_key)
  if (!ts || isNaN(+ts)) {
    return true
  }

  const timeDiff = new Date().getTime() - +ts

  return timeDiff > timeout
}

function saveDate(key: string, prefix: TPrefix): void {
  let _key = buildKey(key, prefix)
  _key = _key + '__dt'
  setCommonItem(_key, new Date().getTime())
}

function removeDate(key: string, prefix: TPrefix): void {
  let _key = buildKey(key, prefix)
  _key = _key + '__dt'
  removeCommonItem(_key)
}

export const getCommonItemWithExpiration: TGetCommonItemWithExpirationFn = function (
  key,
  timeout,
  prefix
) {
  if (isKeyExpired(key, prefix, timeout)) {
    return null
  }

  return getCommonItem(key, prefix)
}

export const setCommonItemWithExpiration: TSetCommonItemFn = function (key, value, prefix) {
  saveDate(key, prefix)

  return setCommonItem(key, value, prefix)
}

export const removeCommonItemWithExpiration: TRemoveCommonItemFn = function (key, prefix) {
  removeDate(key, prefix)

  return removeCommonItem(key, prefix)
}
